import { useMemo } from "react"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import generateModularBlocks from "utils/generateModularBlocks"

import Video, { cssVideo, cssContainer, cssPoster, cssFallback } from "components/media/VideoCLD"

import OverlayRoot, { Overlay, TextContainer } from "./OverlayRoot"
import { getGradient } from "./common"

const Figure = styled.figure`
  position: sticky;
  top: 0;
  grid-column: doc;
  z-index: -1;
  height: 100vh;
  width: 100vw;

  & .${cssContainer} {
    height: 100%;
    transform: scale(1.001);

    .${cssVideo}, .${cssPoster}, .${cssFallback} {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`

export default function VideoOverlay({ className, background_video_cld: background_video, overlay, texts, horizontal_align, title_gradient, chapo_gradient }) {
  const console = useConsole()

  const modularBlocks = useMemo(() => generateModularBlocks(texts, { console }), [])

  const titleGradient = title_gradient?.colors ? getGradient(title_gradient.colors) : null
  const titleGradAngle = title_gradient?.angle && `${title_gradient.angle}deg`
  const chapoGradient = chapo_gradient?.colors ? getGradient(chapo_gradient.colors) : null
  const chapoGradAngle = chapo_gradient?.angle && `${chapo_gradient.angle}deg`

  return (
    <OverlayRoot
      className={className}
      overlay={overlay}
      horizontal_align={horizontal_align}
      titleGradient={titleGradient}
      chapoGradient={chapoGradient}
      titleGradAngle={titleGradAngle}
      chapoGradAngle={chapoGradAngle}
    >
      <Figure>
        {background_video && <Video autoPlay {...background_video} noButton sizes='100vw' />}
        <Overlay />
      </Figure>
      <TextContainer>{modularBlocks}</TextContainer>
    </OverlayRoot>
  )
}
